import { openConfirmModal, openModal } from '@mantine/modals';
import { showNotification } from '@mantine/notifications';
import i18next from 'i18next';
import Cookies from 'js-cookie';

import { Http } from '@mygpt/app/http';

import { cookieConfig, KEY_MYGPT_REFRESH_TOKEN, KEY_MYGPT_TOKEN, KEY_MYGPT_TOKEN_EXPIRESIN } from '../constant';
import { ERROR_DETAIL, ErrorDetailType } from '../constant/error';
import { adminLoginUrl, baseHost, baseUrl, isAdmin } from './index';

export const translateError = (errMsg: string, errorInfo?: ErrorDetailType): string => {
  let knownError = null;
  const errorDetail = errorInfo || ERROR_DETAIL;
  for (const key in errorDetail) {
    if (!errMsg.startsWith(key)) continue;
    const errorValue = errorDetail[key];
    if (typeof errorValue === 'string') {
      knownError = i18next.t(errorValue);
      break;
    }
    if (typeof errorValue === 'object') {
      const nextKey = errMsg.substring(key.length, errMsg.length);
      knownError = translateError(nextKey, errorValue);
      break;
    }
  }
  return knownError || errMsg;
};

/**
 * 错误弹窗提示
 */
export const errorModal = (errMsg: string) => {
  showNotification({
    message: errMsg || i18next.t('errors.unknown.description').toString(),
    color: 'red',
  });
};

/**
 * 超出套餐限制弹窗提示
 */
export const limitErrorModal = () => {
  openConfirmModal({
    centered: true,
    title: i18next.t('pricing.limit_plan').toString(),
    children: i18next.t('pricing.limit_desc').toString(),
    labels: {
      confirm: i18next.t('pricing.upgrade_button').toString(),
      cancel: i18next.t('pricing.contact_us').toString(),
    },
    onCancel: () => {
      window.open(`${baseHost}/support.html`, '_blank');
    },
    onConfirm: () => {
      window.open(`${baseHost}/pricing`, '_blank');
    },
  });
};

let isGbaseReauthorizing = false;

export const handleGbaseRefreshExpired = async () => {
  if (isGbaseReauthorizing) return;
  isGbaseReauthorizing = true;

  try {
    // 保存当前页面路径，授权成功后跳回
    const redirectPath = window.location.pathname + window.location.search;
    localStorage.setItem('gbase_auth_redirect_url', redirectPath);

    // 从 URL 中提取 datasetId（路由格式：/datasets/:datasetId/...）
    const datasetIdMatch = window.location.pathname.match(/\/datasets\/([^/]+)/);
    const dataset_id = datasetIdMatch?.[1];

    // 直接用 Http.use().post() 调用授权接口，避免循环依赖
    const { post } = Http.use();
    const res = await post<{ authorization_url: string; state: string }>('/api/auth/gbase/authorize', {
      ...(dataset_id ? { dataset_id } : {}),
    });

    if (res.data?.authorization_url) {
      // 先提示用户，再跳转重新授权
      showNotification({
        message: i18next.t('gbase.reauth_redirecting', 'GBase authorization expired. Redirecting to re-authorize...'),
        color: 'yellow',
      });
      setTimeout(() => {
        window.location.href = res.data.authorization_url;
      }, 1500);
    }
  } catch (error) {
    isGbaseReauthorizing = false;
    console.error('GBase 重授权失败:', error);
    errorModal(i18next.t('gbase.reauth_failed', 'GBase authorization expired. Please reconnect.'));
  }
};
export const loginExpired = () => {
  Cookies.remove(KEY_MYGPT_TOKEN(), { domain: cookieConfig.COOKIE_DOMAIN });
  Cookies.remove(KEY_MYGPT_REFRESH_TOKEN(), { domain: cookieConfig.COOKIE_DOMAIN });
  Cookies.remove(KEY_MYGPT_TOKEN_EXPIRESIN(), { domain: cookieConfig.COOKIE_DOMAIN });

  if (isAdmin) {
    // Admin 端直接跳转自身登录页
    window.location.href = '/auth/login';
  } else if (adminLoginUrl) {
    // Web 端跳转到 Admin 登录页，带上当前页面地址作为回调
    const redirectUri = btoa(encodeURI(window.location.href));
    window.location.href = `${adminLoginUrl}?redirect_uri=${redirectUri}`;
  } else {
    window.location.href = '/auth/login';
  }
};
